import astroPng from '@/app/img/emoji/astro.png'
import bookPng from '@/app/img/emoji/book.png'
import brokenLovePng from '@/app/img/emoji/broken-love.png'
import childrenPng from '@/app/img/emoji/children.png'
import cookiePng from '@/app/img/emoji/cookie.png'
import crystalPng from '@/app/img/emoji/crystal.png'
import eveningPng from '@/app/img/emoji/evening.png'
import eyesPng from '@/app/img/emoji/eyes.png'
import firePng from '@/app/img/emoji/fire.png'
import flagPng from '@/app/img/emoji/flag.png'
import flowerPng from '@/app/img/emoji/flower.png'
import greenPng from '@/app/img/emoji/green.png'
import heartsPng from '@/app/img/emoji/hearts.png'
import homePng from '@/app/img/emoji/home.png'
import lockPng from '@/app/img/emoji/lock.png'
import loveVioletPng from '@/app/img/emoji/love-violet.png'
import lovePng from '@/app/img/emoji/love.png'
import matchPng from '@/app/img/emoji/match.png'
import messagePng from '@/app/img/emoji/message.png'
import messageIosPng from '@/app/img/emoji/message_ios.png'
import moneyPng from '@/app/img/emoji/money.png'
import morningPng from '@/app/img/emoji/morning.png'
import numsPng from '@/app/img/emoji/nums.png'
import questionPng from '@/app/img/emoji/question.png'
import redPng from '@/app/img/emoji/red.png'
import sexPng from '@/app/img/emoji/sex.png'
import starsPng from '@/app/img/emoji/stars.png'
import synastryPng from '@/app/img/emoji/synastry.png'
import thoughtPng from '@/app/img/emoji/thought.png'
import timePng from '@/app/img/emoji/time.png'
import treePng from '@/app/img/emoji/tree.png'
import weddingPng from '@/app/img/emoji/wedding.png'
import type { FunctionalComponent } from 'preact'
import { useMemo } from 'preact/hooks'
import styles from './index.module.scss'

export const Emoji: FunctionalComponent<{
  size?: number
  type:
    | 'question'
    | 'cookie'
    | 'thought'
    | 'eyes'
    | 'book'
    | 'evening'
    | 'morning'
    | 'brokenLove'
    | 'hearts'
    | 'tree'
    | 'money'
    | 'message'
    | 'message-ios'
    | 'synastry'
    | 'stars'
    | 'crystal'
    | 'love'
    | 'love-violet'
    | 'sex'
    | 'match'
    | 'flag'
    | 'home'
    | 'wedding'
    | 'children'
    | 'fire'
    | 'time'
    | 'flower'
    | 'nums'
    | 'astro'
    | 'lock'
    | 'green'
    | 'red'
}> = props => {
  let url = useMemo(() => {
    switch (props.type) {
      case 'question':
        return questionPng
      case 'cookie':
        return cookiePng
      case 'thought':
        return thoughtPng
      case 'eyes':
        return eyesPng
      case 'book':
        return bookPng
      case 'evening':
        return eveningPng
      case 'morning':
        return morningPng
      case 'brokenLove':
        return brokenLovePng
      case 'lock':
        return lockPng
      case 'astro':
        return astroPng
      case 'nums':
        return numsPng
      case 'flower':
        return flowerPng
      case 'tree':
        return treePng
      case 'time':
        return timePng
      case 'fire':
        return firePng
      case 'children':
        return childrenPng
      case 'wedding':
        return weddingPng
      case 'money':
        return moneyPng
      case 'home':
        return homePng
      case 'flag':
        return flagPng
      case 'match':
        return matchPng
      case 'sex':
        return sexPng
      case 'love':
        return lovePng
      case 'love-violet':
        return loveVioletPng
      case 'crystal':
        return crystalPng
      case 'stars':
        return starsPng
      case 'synastry':
        return synastryPng
      case 'message':
        return messagePng
      case 'message-ios':
        return messageIosPng
      case 'hearts':
        return heartsPng
      case 'green':
        return greenPng
      case 'red':
        return redPng
      default:
        return null
    }
  }, [props.type])

  if (!url) return null

  return (
    <img
      style={{
        width: `${props.size ?? 16}px`,
        height: `${props.size ?? 16}px`,
      }}
      class={styles.img}
      src={url}
      alt=''
    />
  )
}
